module.exports = __webpack_public_path__ + "img/formIcon.da778fd2.png";